import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withCtx as _withCtx, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withKeys as _withKeys, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "px-4 py-6"
};
const _hoisted_2 = {
  key: 0
};
const _hoisted_3 = {
  key: 1
};
const _hoisted_4 = {
  key: 2
};
const _hoisted_5 = {
  class: "flex justify-end mb-4"
};
const _hoisted_6 = {
  key: 1,
  class: "bg-white rounded-lg shadow overflow-hidden"
};
const _hoisted_7 = {
  class: "min-w-full divide-y divide-gray-200 table-fixed"
};
const _hoisted_8 = {
  class: "bg-white divide-y divide-gray-200"
};
const _hoisted_9 = {
  class: "w-[30%] px-6 py-4 whitespace-nowrap"
};
const _hoisted_10 = {
  key: 0,
  class: "text-sm font-medium text-gray-900"
};
const _hoisted_11 = {
  key: 1,
  class: "tw inline-flex items-center w-full mt-0.5"
};
const _hoisted_12 = {
  class: "w-[30%] px-6 py-4 whitespace-nowrap"
};
const _hoisted_13 = {
  key: 0,
  class: "text-sm font-medium text-gray-900"
};
const _hoisted_14 = {
  key: 1,
  class: "flex items-center space-x-2"
};
const _hoisted_15 = {
  class: "text-sm font-medium text-gray-900"
};
const _hoisted_16 = {
  class: "w-[30%] px-6 py-4 whitespace-nowrap"
};
const _hoisted_17 = {
  class: "flex items-center"
};
const _hoisted_18 = {
  key: 1,
  class: "text-sm font-medium text-gray-900"
};
const _hoisted_19 = {
  class: "w-[20%] px-6 py-4 whitespace-nowrap text-sm font-medium text-right"
};
const _hoisted_20 = {
  class: "flex space-x-2 justify-end"
};
const _hoisted_21 = {
  key: 1,
  class: "flex items-center"
};
const _hoisted_22 = {
  key: 2,
  class: "mt-6 bg-green-50 border border-green-200 rounded-lg p-4 text-center",
  "data-cy": "no-split-billing-message"
};
const _hoisted_23 = ["href"];
const _hoisted_24 = {
  key: 3,
  class: "mt-6 bg-green-50 border border-green-200 rounded-lg p-4",
  "data-cy": "split-billing-configured-message"
};
const _hoisted_25 = {
  class: "text-sm text-green-800"
};
const _hoisted_26 = ["href"];
import { ref, computed, onMounted, reactive, nextTick } from 'vue';
import { useMeStore } from '@/services/UserService/useMeStore';
import RouteService from '@/services/RouteService';
import useSplitBillingStore from '@/stores/useSplitBillingStore';
import { storeToRefs } from 'pinia';
import LlTextField from '@/components/LlTextField.vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import AlertBar from '@/components/AlertBar.vue';
import { useSnackbarHandler } from '@/composables/useSnackbarHandler';
import SnackbarComponent from '@/components/SnackbarComponent.vue';
import ClientMatterSearch from '@/components/ClientMatterSearch.vue';
import useClientMatterStore from '@/services/useClientMatterStore';
import LlConfirmationDialog from '@/components/LlConfirmationDialog.vue';
import CreateClient from '@/modules/clients/client/CreateClient.vue';
import { useClientCreation } from '@/composables/useClientCreation';
import { useSupportChat } from '@/composables/useSupportChat';
export default {
  __name: 'MatterSplitBilling',
  props: {
    state: Object,
    stateParams: Object,
    tracking: Object,
    clientMatterManager: Object
  },
  setup(__props) {
    const {
      getSupportUrl: _getSupportUrl
    } = useSupportChat();
    const SPLIT_BILLING_SUPPORT_URL = computed(() => _getSupportUrl('splitBilling'));
    const meStore = useMeStore();
    const {
      features,
      permissions
    } = storeToRefs(meStore);
    const {
      handleError
    } = useSnackbarHandler();
    const splitBillingStore = useSplitBillingStore();
    const {
      allocations,
      loading: storeLoading
    } = storeToRefs(splitBillingStore);
    const {
      getMatterById
    } = useClientMatterStore();
    const props = __props;
    const saving = ref(false);
    const deleting = ref(false);
    const matter = ref({});
    const loadingMatter = ref(false);
    const editingAllocationId = ref(null);
    const originalPercentage = ref(null);
    const originalPrimaryPercentage = ref(null);
    const percentageError = ref('');
    const uiState = reactive({
      loadingReference: false
    });
    const confirmationDialog = ref(null);

    // Client creation functionality using composable
    const {
      showCreateClient,
      createClientRef,
      addNewClient,
      handleClientCreated: handleClientCreatedFromComposable,
      handleClientClosed
    } = useClientCreation({
      onClientCreated: newClient => {
        // Set the newly created client in the cm object
        cm.value.client = newClient;

        // Update the temporary allocation with the new client
        const tempAllocation = allocations.value.find(allocation => allocation.isTemporary && editingAllocationId.value === allocation.id);
        if (tempAllocation) {
          tempAllocation.client = {
            ...newClient
          };

          // Auto-increment matter ID for the new client
          setMatterID(tempAllocation);
        }
      }
    });
    const cm = ref({
      client: {
        id: null,
        name: ''
      },
      matter: {
        id: null,
        name: ''
      }
    });
    const confirmationState = reactive({
      title: '',
      message: '',
      allocationToDelete: null
    });
    const {
      matterId
    } = props.stateParams;
    const loading = computed(() => storeLoading.value);
    onMounted(async () => {
      if (!matterId) {
        handleError('Client/Matter ID is required');
        return;
      }
      await meStore.getMe();
      await loadAllocations();
      loadMatter();
    });
    const cmQueryFilter = computed(() => {
      return {
        originating: false,
        involved: false,
        reviewer: false,
        primary: false,
        status: '',
        archived: false,
        showOrphans: true
      };
    });
    const isSplitBillingEnabled = computed(() => {
      return features.value?.splitBilling || false;
    });
    const showSplitBillingNotice = computed(() => {
      return !isSplitBillingEnabled.value;
    });
    const isAdmin = computed(() => meStore.me?.access?.setup);
    const goToSubscription = () => {
      const routeService = new RouteService({
        state: props.state
      });
      routeService.go('settings.company.maxioCompanySubscription');
    };
    const hasUnsavedChanges = computed(() => {
      const hasTemporary = allocations.value.some(allocation => allocation.isTemporary);
      const hasEditChanges = editingAllocationId.value && originalPercentage.value !== null && allocations.value.find(a => a.id === editingAllocationId.value)?.percentage !== originalPercentage.value;
      return hasTemporary || hasEditChanges;
    });
    const hasValidationErrors = computed(() => {
      return !!percentageError.value;
    });
    const isSecondarySplitMatter = computed(() => {
      return !!matter.value?.isSecondarySplitMatter;
    });

    // Sort allocations to keep primary allocations at the top, temporary at the bottom
    const sortedAllocations = computed(() => {
      return [...allocations.value].sort((a, b) => {
        // Primary allocations come first
        if (a.isPrimary && !b.isPrimary) return -1;
        if (!a.isPrimary && b.isPrimary) return 1;
        // Temporary allocations come last
        if (a.isTemporary && !b.isTemporary) return 1;
        if (!a.isTemporary && b.isTemporary) return -1;
        return 0;
      });
    });
    const loadAllocations = async () => {
      if (!isSplitBillingEnabled.value) return;
      try {
        await splitBillingStore.loadAllocations(matterId);
      } catch (error) {
        handleError(error);
      }
    };
    async function loadMatter() {
      loadingMatter.value = true;
      try {
        matter.value = await getMatterById(matterId, true);
      } catch (error) {
        handleError(error);
      } finally {
        loadingMatter.value = false;
      }
    }
    const openAddAllocation = () => {
      if (isSecondarySplitMatter.value) {
        return;
      }

      // Check if there are unsaved changes
      if (hasUnsavedChanges.value) {
        handleError('Please save or cancel the current edit before adding a new allocation.');
        return;
      }
      cm.value = {
        client: {
          id: null,
          name: ''
        },
        matter: {
          id: null,
          name: ''
        }
      };
      const newAllocation = {
        id: `temp-${Date.now()}`,
        client: {
          id: null
        },
        matter: {
          name: `${matter.value.name}`,
          reference: ''
        },
        percentage: 0,
        isPrimary: false,
        isTemporary: true
      };

      // Add to allocations array
      allocations.value.push(newAllocation);

      // Start editing the new allocation immediately
      startEdit(newAllocation);
    };
    const startEdit = allocation => {
      if (isSecondarySplitMatter.value) {
        return;
      }

      // Check if there are unsaved changes in another allocation
      if (hasUnsavedChanges.value && editingAllocationId.value && editingAllocationId.value !== allocation.id) {
        handleError('Please save or cancel the current edit before editing another allocation.');
        return;
      }
      editingAllocationId.value = allocation.id;
      originalPercentage.value = allocation.percentage;
      const primaryAllocation = getPrimaryAllocation();
      if (primaryAllocation) {
        originalPrimaryPercentage.value = primaryAllocation.percentage;
      }
      percentageError.value = '';
    };
    const saveEdit = async () => {
      if (!editingAllocationId.value) return;
      if (!cm.value.client) {
        handleError('Please select a client before saving the allocation.');
        return false;
      }
      const allocation = allocations.value.find(a => a.id === editingAllocationId.value);
      if (!allocation) return;
      saving.value = true;
      try {
        const currentMatterId = matterId || id;
        if (allocation.isTemporary) {
          // Create new allocation
          const allocationData = {
            clientId: cm.value.client.id,
            splitPercentage: allocation.percentage
          };

          // Add matter reference if provided
          if (allocation.matter?.reference) {
            allocationData.reference = allocation.matter.reference;
          }
          await splitBillingStore.createAllocation(currentMatterId, allocationData);

          // Remove temporary allocation
          const tempIndex = allocations.value.findIndex(a => a.id === editingAllocationId.value);
          if (tempIndex !== -1) {
            allocations.value.splice(tempIndex, 1);
          }
        } else {
          // Update existing allocation
          await splitBillingStore.updateAllocation(allocation.id, {
            matterId: currentMatterId,
            splitPercentage: allocation.percentage
          });
        }

        // Clear editing state
        editingAllocationId.value = null;
        originalPercentage.value = null;
        originalPrimaryPercentage.value = null;
        cm.value = {
          client: {
            id: null,
            name: ''
          },
          matter: {
            id: null,
            name: ''
          }
        };
      } catch (error) {
        handleError(error);
        // Revert to original value on error
        if (allocation && originalPercentage.value !== null) {
          allocation.percentage = originalPercentage.value;
        }
      } finally {
        saving.value = false;
      }
    };
    const cancelEdit = () => {
      if (!editingAllocationId.value) return;
      const allocation = allocations.value.find(a => a.id === editingAllocationId.value);
      if (allocation) {
        if (allocation.isTemporary) {
          // Remove temporary allocation
          const index = allocations.value.findIndex(a => a.id === editingAllocationId.value);
          if (index !== -1) allocations.value.splice(index, 1);
        } else if (originalPercentage.value !== null) {
          // Revert to original value
          allocation.percentage = originalPercentage.value;
        }

        // Revert primary allocation if needed
        if (originalPrimaryPercentage.value !== null) {
          const primaryAllocation = getPrimaryAllocation();
          if (primaryAllocation) {
            primaryAllocation.percentage = originalPrimaryPercentage.value;
          }
        }
      }

      // Reset state
      editingAllocationId.value = null;
      originalPercentage.value = null;
      originalPrimaryPercentage.value = null;
      percentageError.value = '';
      cm.value = {
        client: {
          id: null,
          name: ''
        },
        matter: {
          id: null,
          name: ''
        }
      };
    };
    const getPrimaryAllocation = () => allocations.value.find(a => a.isPrimary);
    const updatePrimaryAllocation = (calculationType, value = null) => {
      const primaryAllocation = getPrimaryAllocation();
      if (!primaryAllocation) return;
      let newPrimaryPercentage;
      switch (calculationType) {
        case 'reset':
          // When clearing input (return to original)
          newPrimaryPercentage = originalPrimaryPercentage.value + originalPercentage.value;
          break;
        case 'difference':
          // Real-time updates based on difference
          const difference = value - (originalPercentage.value || 0);
          newPrimaryPercentage = (originalPrimaryPercentage.value || 0) - difference;
          break;
        case 'direct':
          // Direct assignment (from validation)
          newPrimaryPercentage = value;
          break;
        case 'add':
          // Adding back deleted percentage
          newPrimaryPercentage = primaryAllocation.percentage + value;
          break;
        default:
          return;
      }

      // Always ensure non-negative and apply floating-point precision fix
      const adjustedPrimaryPercentage = Math.max(0, newPrimaryPercentage);
      primaryAllocation.percentage = parseFloat(adjustedPrimaryPercentage.toFixed(2));
    };

    // Shared validation logic
    const validateAndUpdatePrimary = (allocation, percentage, shouldUpdatePrimary = false) => {
      if (percentage < 0) {
        percentageError.value = 'Must be positive';
        return false;
      }
      if (percentage > 100) {
        percentageError.value = 'Max 100%';
        return false;
      }
      const primaryAllocation = getPrimaryAllocation();
      if (primaryAllocation && !allocation.isPrimary) {
        const difference = percentage - (originalPercentage.value || 0);
        const newPrimaryPercentage = (originalPrimaryPercentage.value || 0) - difference;
        const EPSILON = 0.001;
        if (newPrimaryPercentage < -EPSILON) {
          const maxAllowed = (originalPrimaryPercentage.value || 0) + (originalPercentage.value || 0);
          percentageError.value = `Max ${maxAllowed.toFixed(2)}%`;
          return false;
        }
        if (newPrimaryPercentage > 100 + EPSILON) {
          percentageError.value = 'Primary exceeds 100%';
          return false;
        }

        // Update primary allocation if validation passes and requested
        if (shouldUpdatePrimary) {
          updatePrimaryAllocation('direct', newPrimaryPercentage);
        }
      }
      percentageError.value = '';
      return true;
    };
    const validatePercentage = allocation => {
      // Handle partial decimal input gracefully
      if (typeof allocation.percentage === 'string' && allocation.percentage.endsWith('.')) {
        allocation.percentage = parseFloat(allocation.percentage) || 0;
      }
      validateAndUpdatePrimary(allocation, allocation.percentage, true);
    };
    const updatePercentage = (allocation, newPercentage) => {
      allocation.percentage = newPercentage;
      percentageError.value = '';
      if (newPercentage === '' || newPercentage === null || newPercentage === undefined) {
        allocation.percentage = 0;
        if (!allocation.isPrimary) {
          updatePrimaryAllocation('reset');
        }
        return;
      }

      // Handle partial decimal input (like "22." while typing)
      const percentageStr = String(newPercentage);
      if (percentageStr.endsWith('.') && !isNaN(parseFloat(percentageStr.slice(0, -1)))) {
        return; // Allow typing decimal point
      }
      const percentage = parseFloat(newPercentage);
      if (isNaN(percentage)) return; // Don't show error for partial input

      // Update the current allocation percentage first
      allocation.percentage = parseFloat(percentage.toFixed(2));

      // Calculate and update primary allocation immediately for real-time feedback
      if (!allocation.isPrimary) {
        updatePrimaryAllocation('difference', percentage);
      }

      // Validate the change (but don't update primary again since we already did it above)
      validateAndUpdatePrimary(allocation, percentage, false);
    };
    const deleteAllocation = async allocationId => {
      if (isSecondarySplitMatter.value) {
        return;
      }

      // Check if there are unsaved changes
      if (hasUnsavedChanges.value) {
        handleError('Please save or cancel the current edit before deleting an allocation.');
        return;
      }
      const allocation = allocations.value.find(a => a.id === allocationId);
      if (!allocation) return;

      // Set up confirmation dialog
      confirmationState.allocationToDelete = allocationId;
      confirmationState.title = 'Delete Allocation';
      confirmationState.message = `Are you sure you want to delete the allocation for ${allocation.client.name}?`;

      // Show confirmation dialog
      confirmationDialog.value.open();
    };
    const handleConfirmDelete = async () => {
      if (!confirmationState.allocationToDelete) return;
      deleting.value = true;
      try {
        const allocationToDelete = allocations.value.find(a => a.id === confirmationState.allocationToDelete);
        const deletedPercentage = allocationToDelete ? allocationToDelete.percentage : 0;
        await splitBillingStore.deleteAllocation(confirmationState.allocationToDelete);
        if (deletedPercentage > 0) {
          updatePrimaryAllocation('add', deletedPercentage);
        }
      } catch (error) {
        handleError(error);
      } finally {
        deleting.value = false;
        confirmationState.allocationToDelete = null;
      }
    };
    const clientSelected = () => {
      const tempAllocation = allocations.value.find(allocation => allocation.isTemporary && editingAllocationId.value === allocation.id);
      if (tempAllocation) {
        tempAllocation.client = {
          ...cm.value.client
        };

        // Auto-increment matter ID if client is selected
        if (cm.value.client?.id) {
          setMatterID(tempAllocation);
        }
      }
    };
    async function setMatterID(allocation) {
      if (!cm.value.client?.id) return;
      uiState.loadingReference = true;
      try {
        const result = await meStore.getMyCompanyReferences(cm.value.client.id);
        allocation.matter.reference = result.nextMatterReference;
      } catch (error) {
        handleError(error);
      } finally {
        uiState.loadingReference = false;
      }
    }
    return (_ctx, _cache) => {
      const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(SnackbarComponent, {
        ref: "snackbar"
      }, null, 512), _createVNode(LlConfirmationDialog, {
        ref_key: "confirmationDialog",
        ref: confirmationDialog,
        title: confirmationState.title,
        message: confirmationState.message,
        onConfirm: handleConfirmDelete
      }, null, 8, ["title", "message"]), _unref(showCreateClient) ? (_openBlock(), _createBlock(CreateClient, {
        key: 0,
        ref_key: "createClientRef",
        ref: createClientRef,
        state: __props.state,
        stateParams: __props.stateParams,
        clientMatterManager: __props.clientMatterManager,
        onClientCreated: _unref(handleClientCreatedFromComposable),
        onClose: _unref(handleClientClosed),
        isfromVue: true
      }, null, 8, ["state", "stateParams", "clientMatterManager", "onClientCreated", "onClose"])) : _createCommentVNode("", true), showSplitBillingNotice.value ? (_openBlock(), _createBlock(AlertBar, {
        key: 1,
        type: "success",
        variant: "tonal",
        class: "max-w-[350px]",
        "data-cy": "product-notice"
      }, {
        default: _withCtx(() => [_createElementVNode("p", null, [_cache[0] || (_cache[0] = _createTextVNode(" Split billing is not available in your subscription. ", -1)), isAdmin.value ? (_openBlock(), _createElementBlock("span", _hoisted_2, "Upgrade now or speak with our success team for more information.")) : (_openBlock(), _createElementBlock("span", _hoisted_3, "Please talk to your LeanLaw administrator to upgrade your account."))]), _createElementVNode("p", null, [isAdmin.value ? (_openBlock(), _createBlock(LlSecondaryButton, {
          key: 0,
          color: "primary",
          onClick: _withModifiers(goToSubscription, ["prevent"])
        }, {
          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createTextVNode("Upgrade Now", -1)]))]),
          _: 1
        })) : _createCommentVNode("", true), _createVNode(LlSecondaryButton, {
          href: "https://leanlaw.co/pricing",
          target: "_blank",
          rel: "noopener noreferrer",
          class: "ml-5"
        }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createTextVNode(" Learn More ", -1), _createElementVNode("span", {
            class: "fa fa-external-link"
          }, null, -1)]))]),
          _: 1
        })])]),
        _: 1
      })) : (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(LlSecondaryButton, {
        "data-cy": "add-allocation",
        onBtnClick: openAddAllocation,
        color: "primary",
        variant: "flat",
        "prepend-icon": "mdi-plus",
        loading: !!loadingMatter.value,
        disabled: !!hasUnsavedChanges.value || isSecondarySplitMatter.value
      }, {
        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [_createTextVNode(" Add Client to Split Billing ", -1)]))]),
        _: 1
      }, 8, ["loading", "disabled"])]), loading.value ? (_openBlock(), _createBlock(_component_v_skeleton_loader, {
        key: 0,
        type: "card"
      })) : (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("table", _hoisted_7, [_cache[6] || (_cache[6] = _createElementVNode("thead", {
        class: "bg-gray-50"
      }, [_createElementVNode("tr", null, [_createElementVNode("th", {
        class: "w-[40%] px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
      }, " Client "), _createElementVNode("th", {
        class: "w-[30%] px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
      }, " Matter "), _createElementVNode("th", {
        class: "w-[15%] px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
      }, " Split Allocation % "), _createElementVNode("th", {
        class: "w-[15%] px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider"
      }, " Actions ")])], -1)), _createElementVNode("tbody", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedAllocations.value, allocation => {
        return _openBlock(), _createElementBlock("tr", {
          key: allocation.id,
          class: _normalizeClass(['hover:bg-gray-50', allocation.isTemporary ? 'bg-green-50 hover:bg-green-50 border-l-4' : allocation.isPrimary ? 'bg-gray-50' : ''])
        }, [_createElementVNode("td", _hoisted_9, [!allocation.isTemporary ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(allocation.client?.name), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_11, [_createVNode(ClientMatterSearch, {
          class: "w-full",
          emitOnAnyChange: true,
          cm: cm.value,
          "query-filter": cmQueryFilter.value,
          "client-only": true,
          "hide-client-label": true,
          showAddClientMatter: _unref(permissions).matters?.create,
          onMatterChange: clientSelected,
          onAddNewClient: _unref(addNewClient),
          "data-cy": "client-matter-search"
        }, null, 8, ["cm", "query-filter", "showAddClientMatter", "onAddNewClient"])]))]), _createElementVNode("td", _hoisted_12, [!allocation.isTemporary ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(allocation.matter?.name), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_14, [_createVNode(LlTextField, {
          modelValue: allocation.matter.reference,
          "onUpdate:modelValue": $event => allocation.matter.reference = $event,
          disabled: uiState.loadingReference,
          placeholder: uiState.loadingReference ? 'Loading...' : 'Optional Id/Number',
          "hide-details": true,
          maxlength: 50,
          class: "text-sm flex-shrink-0",
          style: {
            "width": "160px",
            "max-width": "160px"
          },
          "data-cy": "matter-id-input"
        }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "placeholder"]), _cache[4] || (_cache[4] = _createElementVNode("span", {
          class: "text-sm font-medium text-gray-500"
        }, "-", -1)), _createElementVNode("div", _hoisted_15, _toDisplayString(allocation.matter?.name), 1)]))]), _createElementVNode("td", _hoisted_16, [_createElementVNode("div", _hoisted_17, [!allocation.isPrimary && editingAllocationId.value === allocation.id ? (_openBlock(), _createBlock(LlTextField, {
          key: 0,
          modelValue: allocation.percentage,
          "onUpdate:modelValue": $event => updatePercentage(allocation, $event),
          onBlur: $event => validatePercentage(allocation),
          onKeyup: _withKeys(cancelEdit, ["escape"]),
          type: "number",
          min: 0,
          max: 100,
          step: 0.01,
          density: "compact",
          variant: "outlined",
          suffix: "%",
          class: "text-sm",
          ref_for: true,
          ref: "percentageInput",
          hideDetails: !percentageError.value,
          "error-messages": percentageError.value,
          "data-cy": "percentage-input"
        }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur", "hideDetails", "error-messages"])) : (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(allocation.percentage) + "% ", 1))])]), _createElementVNode("td", _hoisted_19, [_createElementVNode("div", _hoisted_20, [!allocation.isPrimary ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [editingAllocationId.value === allocation.id ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createVNode(LlSecondaryButton, {
          icon: "mdi-check",
          size: "small",
          color: "primary",
          variant: "text",
          onClick: saveEdit,
          disabled: saving.value || hasValidationErrors.value,
          title: "Save changes",
          "aria-label": "Save changes",
          "data-cy": "save-changes"
        }, null, 8, ["disabled"]), _createVNode(LlSecondaryButton, {
          icon: "mdi-close",
          size: "small",
          variant: "text",
          onClick: cancelEdit,
          title: "Cancel changes",
          "aria-label": "Cancel changes"
        })], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_createVNode(LlSecondaryButton, {
          icon: "mdi-pencil",
          size: "small",
          variant: "text",
          onClick: $event => startEdit(allocation),
          disabled: hasUnsavedChanges.value && editingAllocationId.value !== allocation.id || isSecondarySplitMatter.value || loadingMatter.value,
          title: "Edit allocation",
          "aria-label": "Edit allocation",
          "data-cy": "edit-allocation"
        }, null, 8, ["onClick", "disabled"]), _createVNode(LlSecondaryButton, {
          icon: "mdi-delete",
          size: "small",
          color: "error",
          variant: "text",
          onClick: $event => deleteAllocation(allocation.id),
          disabled: deleting.value || hasUnsavedChanges.value || isSecondarySplitMatter.value || loadingMatter.value,
          title: "Delete allocation",
          "aria-label": "Delete allocation",
          "data-cy": "delete-allocation"
        }, null, 8, ["onClick", "disabled"])], 64))], 64)) : (_openBlock(), _createElementBlock("div", _hoisted_21, [...(_cache[5] || (_cache[5] = [_createElementVNode("span", {
          class: "inline-flex items-center px-4 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-light"
        }, " Primary ", -1)]))]))])])], 2);
      }), 128))])])])), _unref(allocations).length === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_22, [_cache[7] || (_cache[7] = _createElementVNode("p", {
        class: "text-gray-600 text-sm mb-3"
      }, " Configure this matter so that invoices are split between multiple clients based on a percentage. ", -1)), _createElementVNode("a", {
        href: SPLIT_BILLING_SUPPORT_URL.value,
        target: "_blank",
        rel: "noopener noreferrer",
        class: "text-primary hover:!text-[rgb(var(--v-theme-primary-darken-1))] underline text-sm font-bold"
      }, " Learn more about split billing ", 8, _hoisted_23)])) : _createCommentVNode("", true), _unref(allocations).length > 1 ? (_openBlock(), _createElementBlock("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_cache[8] || (_cache[8] = _createElementVNode("ul", {
        class: "list-disc list-inside space-y-1 mb-3"
      }, [_createElementVNode("li", null, "Time, expenses, and fixed fee should all be added to the primary client"), _createElementVNode("li", null, "Drafts are edited for the primary client, then split into multiple invoices when finalized and sent to QuickBooks"), _createElementVNode("li", null, "Changing split billing breakdown will affect invoices in draft and future invoices")], -1)), _createElementVNode("a", {
        href: SPLIT_BILLING_SUPPORT_URL.value,
        target: "_blank",
        rel: "noopener noreferrer",
        class: "text-primary hover:!text-[rgb(var(--v-theme-primary-darken-1))] underline text-sm font-bold"
      }, " Learn more about split billing ", 8, _hoisted_26)])])) : _createCommentVNode("", true)]))]);
    };
  }
};